import { useContext, useEffect, useState } from 'react';
import { Button, Col, Modal, Row, Table } from 'reactstrap';
import moment from 'moment';
import { Context as AuthContext } from '../../../../contexts/AuthContext';
import ManagementOfferLetter from '../../Staff/ManagementOfferLetter';
import StaffOfferLetter from '../../Staff/StaffOfferLetter';
import Pto from '../../../../services/Pto';
import EmployeeService from '../../../../services/Employee';
import EmployeeTitlesService from '../../../../services/EmployeeTitles';
import isAdmin from '../../../../helpers/isAdmin';
import isHRUser from '../../../../helpers/isHRUser';
import SchoolService from '../../../../services/School';

const OfferLetterView = ({
  employee,
  user,
  loggedUser,
  setUploadingDocumentType,
  fileInputRef,
  uploadedOfferLetter,
  removeAlert,
}: any) => {
  const { currentSchool, currentFranchisee, token }: any = useContext(AuthContext);
  const [show, setShow] = useState(false);
  const [ptoPolices, setPtoPolices] = useState([] as any[]);
  const [titleList, setTitleList] = useState([{}]);
  const [employees, setEmployees] = useState<any>([]);
  const [schoolResult, setSchoolResult] = useState<any>([]);

  useEffect(() => {
    const getSchool = async () => {
      try {
        const result = await SchoolService(token).show(currentSchool?.value);
        const d = result?.data || {};
        setSchoolResult(d);
      } catch (e) {
        console.error('Error on get school');
      }
    };
    getSchool();
  }, [currentSchool]);

  const listPtoPolices = async () => {
    try {
      const result = await Pto(token).ptoPolicyList();
      setPtoPolices(result.data || []);
    } catch (e: any) {
      console.error(e?.response?.data?.message || 'No data Found!');
    }
  };

  const listTitles = async () => {
    try {
      const result = await EmployeeTitlesService(token).list();
      setTitleList(result.data || []);
    } catch (e: any) {
      console.error(e?.response?.data?.message || 'No titles found');
    }
  };

  const listEmployees = async () => {
    const idSchool = currentSchool.value;
    const { data } = await EmployeeService(token).listSelectStaff(idSchool);
    setEmployees(data);
  };

  const handleFindTitleName = (titleId: string) => {
    const titleName: any = titleList.find((value: any) => value.id === titleId);

    return titleName?.name;
  };

  const handleFindSupervisorName = (supervisorId: string) => {
    const supervisorName: any = employees.find((value: any) => value.userId === supervisorId);
    const firstName = supervisorName?.firstName || supervisorName?.user?.firstName || '';
    const lastName = supervisorName?.lastName || supervisorName?.user?.lastName || '';
    return `${firstName}  ${lastName}`;
  };

  useEffect(() => {
    listEmployees();
    listTitles();
    listPtoPolices();
  }, [currentSchool, currentFranchisee]);

  const terminationPaperworkUrl =
    (employee?.terminationDetails || [])
      .filter((t: any) => t?.signedDocumentUrl)
      .sort((a: any, b: any) => new Date(b?.createdAt || 0).getTime() - new Date(a?.createdAt || 0).getTime())[0]
      ?.signedDocumentUrl || null;

  return (
    <Row>
      <Table className="mt-4" responsive>
        <thead>
          <tr>
            <th style={{ background: '#f3f3f3', borderTop: '1px solid #dadada' }}>
              <div className="d-flex align-items-center py-2">Offer Letter</div>
            </th>
          </tr>
        </thead>
        <tbody></tbody>
      </Table>
      <Table className="align-items-center table-flush" responsive>
        <tbody>
          <tr>
            <th>Name</th>
            <th>Action</th>
          </tr>
          {terminationPaperworkUrl && (
            <tr>
              <td>
                <div className="d-flex align-items-center">
                  <i className="fas fa-file mr-2" />
                  Termination Paperwork
                </div>
              </td>
              <td>
                <a href={terminationPaperworkUrl} target="_blank" rel="noreferrer">
                  <i className="fas fa-eye" style={{ cursor: 'pointer' }}></i>
                </a>
              </td>
            </tr>
          )}
          <tr>
            <td>
              <div className="d-flex align-items-center">
                <i className="fas fa-file mr-2" />
                Offer Letter
              </div>
            </td>
            <td>
              {employee?.offerLetter ? (
                <div className="d-flex align-items-center" style={{ gap: 8 }}>
                  <Button style={{ border: 'none', boxShadow: 'none', padding: 0 }} onClick={() => setShow(true)}>
                    <i className="fas fa-eye" style={{ cursor: 'pointer' }}></i>
                  </Button>
                </div>
              ) : uploadedOfferLetter?.uploadedPdf ? (
                <div className="d-flex align-items-center" style={{ gap: 8 }}>
                  <a href={uploadedOfferLetter?.uploadedPdf} target="_blank">
                    <i className="fas fa-eye" style={{ cursor: 'pointer' }}></i>
                  </a>
                  {(isAdmin(loggedUser) || isHRUser(loggedUser)) && (
                    <Button
                      className="mt-n1 ml-1"
                      style={{ border: 'none', boxShadow: 'none', padding: 0 }}
                      onClick={(e) => removeAlert(e, uploadedOfferLetter?.id || '')}
                    >
                      <i className="far fa-trash-alt text-danger" />
                    </Button>
                  )}
                </div>
              ) : (
                <>
                  {isAdmin(loggedUser) || isHRUser(loggedUser) ? (
                    <>
                      <Button
                        style={{ border: 'none', boxShadow: 'none', padding: 0 }}
                        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                          e.preventDefault();
                          setUploadingDocumentType('OFFER_LETTER');
                          fileInputRef?.current?.click();
                        }}
                      >
                        <i className="fa fa-upload" />
                      </Button>
                    </>
                  ) : (
                    <>
                      Incomplete <i className="fas fa-ban" style={{ color: 'red' }} />
                    </>
                  )}
                </>
              )}
            </td>
          </tr>
        </tbody>
      </Table>
      <Modal className="modal-dialog-centered" size="xl" isOpen={show} toggle={() => setShow(false)}>
        <div className="modal-header pb-1">
          <h5 className="modal-title">{`${user?.firstName} ${user?.lastName}`}</h5>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => setShow(false)}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <div className="modal-body pt-0">
          <Row className="mt-2">
            <Col lg="12" className="mt-4" style={{ maxHeight: '500px', overflow: 'scroll' }}>
              {employee?.offerLetter === 'Management' ? (
                <ManagementOfferLetter
                  school={schoolResult}
                  user={user}
                  email={user?.email}
                  phone={user?.phone}
                  firstName={user?.firstName}
                  lastName={user?.lastName}
                  hireDate={employee?.startDate ? moment(employee?.startDate).format('MM/DD/YYYY') : ''}
                  classification={employee?.workday}
                  currentSchool={currentSchool}
                  paymentFrequency={employee?.paymentFrequency || ''}
                  amount={employee?.payRate || ''}
                  readOnly={true}
                  signature={employee?.supervisor?.name || ''}
                  signatureStaff={employee?.offerLetterSignature || ''}
                  policy={employee?.ptoPolicyId}
                  ptoPolices={ptoPolices}
                  handleFindTitleName={() => handleFindTitleName(employee?.titleId)}
                  handleFindSupervisorName={() => handleFindSupervisorName(employee?.supervisorId)}
                />
              ) : (
                <></>
              )}
              {employee?.offerLetter === 'Staff' ? (
                <StaffOfferLetter
                  school={schoolResult}
                  user={user}
                  email={user?.email}
                  phone={user?.phone}
                  firstName={user?.firstName}
                  lastName={user?.lastName}
                  hireDate={employee?.startDate ? moment(employee?.startDate).format('MM/DD/YYYY') : ''}
                  classification={employee?.workday}
                  paymentFrequency={employee?.paymentFrequency || ''}
                  amount={employee?.payRate || ''}
                  readOnly={true}
                  signature={employee?.supervisor?.name || ''}
                  signatureStaff={employee?.offerLetterSignature || ''}
                  handleFindTitleName={() => handleFindTitleName(employee?.titleId)}
                  handleFindSupervisorName={() => handleFindSupervisorName(employee?.supervisorId)}
                />
              ) : (
                <></>
              )}
              {!employee?.offerLetter ? <span>Offer Letter not included.</span> : <></>}
            </Col>
          </Row>
        </div>
      </Modal>
    </Row>
  );
};

export default OfferLetterView;
